import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin, ArrowRight } from "lucide-react";
import { useSeo, PHONE, PHONE_HREF, EMAIL, ADDRESS, ADDRESS_MAP_URL } from "@/lib/site";
import { Reveal, MaskLines } from "@/components/Reveal";

export default function Contact() {
  useSeo("Contact — Breeze Craft Sydney", "Call, email or visit Breeze Craft. Sydney-wide breeze block supply and installation, Mon–Fri 7am–5pm.");
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-14 sm:py-20" data-testid="contact-page">
      <p className="kicker mb-4">Contact</p>
      <h1 className="font-display text-4xl sm:text-6xl font-medium tracking-tight text-ink" data-testid="contact-heading">
        <MaskLines lines={["Talk to a human."]} />
      </h1>
      <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-12">
        <Reveal delay={0.15} className="space-y-px border border-ink/10 bg-ink/10">
          <a href={PHONE_HREF} data-testid="contact-phone-link" className="flex items-center gap-5 bg-bone p-6 group">
            <Phone size={20} className="text-terracotta shrink-0" />
            <div>
              <p className="kicker">Phone</p>
              <p className="mt-1 font-display text-xl font-medium text-ink group-hover:text-terracotta transition-colors">{PHONE}</p>
            </div>
          </a>
          <a href={`mailto:${EMAIL}`} data-testid="contact-email-link" className="flex items-center gap-5 bg-bone p-6 group">
            <Mail size={20} className="text-terracotta shrink-0" />
            <div>
              <p className="kicker">Email</p>
              <p className="mt-1 font-display text-xl font-medium text-ink group-hover:text-terracotta transition-colors">{EMAIL}</p>
            </div>
          </a>
          <div className="flex items-center gap-5 bg-bone p-6">
            <Clock size={20} className="text-terracotta shrink-0" />
            <div>
              <p className="kicker">Hours</p>
              <p className="mt-1 text-sm text-ink">Mon–Fri 7:00am–5:00pm · Sat by appointment</p>
            </div>
          </div>
          <div className="flex items-center gap-5 bg-bone p-6">
            <MapPin size={20} className="text-terracotta shrink-0" />
            <div>
              <p className="kicker">Yard</p>
              <a href={ADDRESS_MAP_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-address-link" className="mt-1 block text-sm text-ink hover:text-terracotta transition-colors">{ADDRESS}</a>
              <p className="mt-1 text-xs text-neutral-500">Pickups by arrangement</p>
            </div>
          </div>
          <div className="bg-bone p-6">
            <Link to="/quote" data-testid="contact-quote-button" className="inline-flex items-center gap-2 bg-terracotta text-white px-6 py-3 text-sm font-semibold hover:bg-terracotta-dark transition-colors">
              Fastest: quote form <ArrowRight size={15} />
            </Link>
          </div>
        </Reveal>
        <Reveal delay={0.25}>
          <div className="aspect-[4/3] lg:aspect-auto lg:h-full min-h-[320px] border border-ink/10 overflow-hidden" data-testid="contact-map">
            <iframe
              title="Breeze Craft yard — 2 Campsie Street, Wilton NSW"
              src={`https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`}
              className="w-full h-full min-h-[320px] grayscale contrast-[1.05]"
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
